
const Spec = (props) => {
    return (
        <div className={props.RowClassName}>
            <span className='cs-label'>{props.LabelDisplayText}</span> <span className='cs-spec'>{props.Value}</span>
        </div>
    );
};

export default Spec;